import Rails from '@rails/ujs'
import './alpine'
import '../controllers/cancer'
import '../css/cancer.scss'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
